import React from "react";

const StockLogo = ({ color, size }) => {
  return (
    <svg
      width={size ? size : "8"}
      height={size ? size : "8"}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.23775 2.27752L5.31374 2.39684C5.3038 2.22781 5.2574 2.077 5.17454 1.94442C5.09499 1.80853 4.97733 1.70082 4.82156 1.62127C4.66909 1.54173 4.47686 1.50195 4.24485 1.50195C3.89684 1.50195 3.58694 1.5815 3.31516 1.74059C3.04338 1.89968 2.88926 2.10352 2.85281 2.35209C2.82298 2.51119 2.86441 2.64542 2.9771 2.75479C3.08978 2.86417 3.31682 2.95697 3.6582 3.0332L5.00053 3.31161C5.71644 3.46407 6.23349 3.71763 6.55167 4.07227C6.87317 4.42691 6.98751 4.89092 6.89471 5.46431C6.81185 5.95153 6.59807 6.37743 6.25337 6.74201C5.90868 7.10328 5.47118 7.385 4.94087 7.58718C4.41057 7.78604 3.82227 7.88548 3.17596 7.88548C2.13855 7.88548 1.34973 7.67335 0.809482 7.24911C0.269235 6.82487 0.0090554 6.24982 0.0289418 5.52397L2.09712 5.4146C2.1137 5.72615 2.22307 5.96147 2.42525 6.12056C2.62743 6.27634 2.90418 6.35588 3.2555 6.3592C3.64992 6.36583 3.98467 6.28462 4.25977 6.11559C4.53817 5.94324 4.69561 5.73443 4.73207 5.48917C4.75858 5.31682 4.70887 5.17762 4.58292 5.07156C4.46029 4.96549 4.23491 4.87766 3.90678 4.80806L2.63406 4.54457C1.91152 4.39542 1.39281 4.12861 1.07795 3.74414C0.76308 3.35967 0.655362 2.8708 0.754794 2.27752C0.83434 1.80356 1.03155 1.39755 1.34641 1.05948C1.6646 0.718099 2.07392 0.456262 2.5744 0.27397C3.07818 0.0916786 3.6466 0.000532746 4.27965 0.000532746C5.27066 0.000532746 6.01639 0.204368 6.51687 0.612038C7.02066 1.01971 7.26095 1.57487 7.23775 2.27752Z"
        fill={color || "#2D3748"}
      />
    </svg>
  );
};

export default StockLogo;

